import { SUBSCRIPTION_RECEIVED } from './types';
import api from 'api';

export const subscriptionReceived = data => ({
  type: SUBSCRIPTION_RECEIVED,
  data
})

export const getSubscription = () => (dispatch) =>
  api.account.getSubscriptionInfo().then( res => {    
    sessionStorage.setItem('subscription', res.type.toLowerCase())
    dispatch(subscriptionReceived(res))
  })
